import {cloneDeep} from 'lodash';
import {Injectable, TemplateRef} from '@angular/core';
import {Params} from '@angular/router';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {AnyObject} from '../../interfaces/utils';

export interface IPanelUtilitiesModel {
  float: boolean;
  tplPanel?: TemplateRef<any>;
  hasTemplate?: boolean;
  closed: boolean;
  innerWidthPage?: number;
  routerParams?: AnyObject;
  mainMenuActive?: boolean;
  isVisible: boolean | null; // Si es null, no se realiza ninguna acción
}

export namespace PanelUtilitiesActions {
  export class ToggleClosed {
    static readonly type: string = '[Panel] Toogle Closed Panel Action';
    constructor() { }
  }

  export class SetIsVisible {
    static readonly type: string = '[Panel] Is Visible Panel Action';
    constructor(public isVisible: boolean | null) { }
  }

  export class SetRouterParams {
    static readonly type: string = '[Panel] Set Router Params To Panel Utilities Action';
    constructor(public params: Params) { }
  }

  export class ChangeServiceExpert {
    static readonly type: string = '[Panel] Change Service Expert Action';
    constructor(public expertId: string) { }
  }

  export class MainMenuActive {
    static readonly type: string = '[Panel] Main Menu Active Action';
    constructor(public value: boolean) { }
  }
}

@State<IPanelUtilitiesModel>({
  name: 'panelUtilitiesState',
  defaults: {
    float: false,
    closed: false,
    isVisible: null,
  }
})
@Injectable()
export class PanelUtilitiesState {
  constructor() { }

  @Selector()
  static getTemplatePanel(state: IPanelUtilitiesModel): TemplateRef<any> {
    return state.tplPanel;
  }

  @Selector()
  static getClosed(state: IPanelUtilitiesModel): boolean {
    return state.closed;
  }

  @Selector()
  static getIsVisible({isVisible}: IPanelUtilitiesModel): boolean | null {
    return isVisible;
  }

  @Selector()
  static getRouterParams(state: IPanelUtilitiesModel): AnyObject {
    return state.routerParams;
  }

  @Selector()
  static getMainMenuActive(state: IPanelUtilitiesModel): boolean {
    return state.mainMenuActive;
  }

  @Action(PanelUtilitiesActions.ToggleClosed)
  toggleClosedPanelAction(ctx: StateContext<IPanelUtilitiesModel>, action: PanelUtilitiesActions.ToggleClosed): void {
    const state = cloneDeep(ctx.getState());
    ctx.patchState({
      closed: !state?.closed
    });
  }

  @Action(PanelUtilitiesActions.SetRouterParams)
  setRouterParamsToPanelUtilitiesAction(ctx: StateContext<IPanelUtilitiesModel>, action: PanelUtilitiesActions.SetRouterParams): void {
    ctx.patchState({
      routerParams: action.params
    });
  }

  @Action(PanelUtilitiesActions.ChangeServiceExpert)
  changeServiceExpertAction(ctx: StateContext<IPanelUtilitiesModel>, action: PanelUtilitiesActions.ChangeServiceExpert): void {
    const params: Params = { ...ctx.getState().routerParams, expert: action.expertId };
    ctx.patchState({
      routerParams: params
    });
  }

  @Action(PanelUtilitiesActions.MainMenuActive)
  mainMenuActiveAction(ctx: StateContext<IPanelUtilitiesModel>, action: PanelUtilitiesActions.MainMenuActive): void {
    ctx.patchState({
      mainMenuActive: action.value
    });
  }

  @Action(PanelUtilitiesActions.SetIsVisible)
  isVisiblePanelAction(ctx: StateContext<IPanelUtilitiesModel>, {isVisible}: PanelUtilitiesActions.SetIsVisible): void {
    ctx.patchState({isVisible});
  }

}
